<div class="unit-system-selector" [ngClass]="{'selected': selected}" (click)="handleClick($event)">
  <div class="label" [ngClass]="{'selected': selected}">{{unitSystem.label | titlecase}}</div>
</div>
